module.exports = __webpack_public_path__ + "img/aws-ses-logo.ec0b4b39.png";